import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    position: "relative",
    minHeight: "80vh",
    // TODO: add constant
    paddingTop: 70,
    paddingBottom: 72,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  header: {
    width: "-webkit-fill-available",
    display: "flex",
    position: "fixed",
    top: 0,
    alignItems: "center",
    padding: "12px 16px 12px 8px",
    gap: theme.spacing.space8,
    background: theme.colors.Background1,
    zIndex: theme.zIndex.appBar,
  },
  icon: {
    padding: theme.spacing.space8,
  },
  searchIcon: {
    color: theme.colors.TextSilver,
  },
  container: {
    display: "grid",
    padding: `8px 16px`,
    gap: theme.spacing.space16,
  },
  noResult: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    position: "absolute",
    width: `calc(100vw - ${theme.spacing.space32}px)`,
    top: "30%",
    overflow: "hidden",
  },
  inviteBtn: {
    marginTop: theme.spacing.space16,
  },
}));
